//Styles ============================================
require('../css/app.scss');


//Scripts ===========================================
require('./modules.js');
require('./top-menu.js');
require('./compare.js');
require('./modules/slider.js');
require('./modules/carousel.js');
require('./modules/custom-form.js');
require('./modules/variants.js');
require('./modules/download.js');
require('./modules/contact.js');
require('./modules/pageNavigation.js');
require('./modules/animations.js');
require('./modules/filter.js');
require('./modules/jobs-list.js');
require('./modules/accordion.js');
require('./modules/faq.js');
require('./modules/gallery-lightbox.js');
require('./modules/map.js');
require('./modules/search.js');
require('./modules/share.js');
require('./modules/scrollToElement.js');
require('./modules/tables.js');
// require("jquery");
// require('jquery-colorbox');
// require('slick-carousel');


//////////////////
// WEBPACK FOOTER
// ./js/app.js
// module id = 4
// module chunks = 0